import { Spin } from 'antd'
import React, { useState } from 'react'
import Circular from '../../../../components/Loader/Circular/Circular'
import { useDispatch } from 'react-redux';
import { setError, setMessage } from '../../../../store/common/generalSlice';
import { useMutation } from 'react-query';
import axiosInstance from '../../../../config/api';


const PromoCode = ({ onChange }) => {

    const [promo, setPromo] = useState('');
    const dispatch = useDispatch();

    const promoMutation = useMutation(async (data) => {

        let payload = {
            code: data,
            purpose: "Advertisement"
        }

        let res = await axiosInstance.post('/user/validate-promo-code', payload);
        dispatch(setMessage(res?.data?.data?.message))
        return res
    },
        {
            onSuccess: (res) => {
                onChange(res?.data?.data?.promoCode)
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }

    )

    const applyHandler = () => {
        if (promo) {
            promoMutation.mutate(promo)
        }
        else {
            dispatch(setError('Promo code is required'))
        }
    }

    return (
        <div className='w-full relative'>
            <input type='text' placeholder='Add Promo Code' className={'promoStyle px-2 py-3 rounded-md w-full outline-none pr-[110px]'} value={promo} onChange={(e) => setPromo(e?.target?.value)} />
            <div className='absolute bg-[#fab700] w-1/4 h-full right-0 bottom-0 rounded-tr-md rounded-br-md flex items-center justify-center font-medium cursor-pointer text-base text-white' onClick={() => applyHandler()}>
                <Circular spinning={promoMutation?.isLoading} className='mr-2' color={'white'} />
                Apply
            </div>
        </div>
    )
}

export default PromoCode